var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "component-page"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "head__body"
  }, [_c('button', {
    staticClass: "head__back",
    attrs: {
      "aria-label": "Back"
    },
    on: {
      "click": function click($event) {
        _vm.$previousRoute.name ? _vm.$router.back() : _vm.$router.push({
          name: 'home'
        });
      }
    }
  }, [_c('arrow-left-icon')], 1), _c('h1', {
    staticClass: "head__title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])])]), _c('div', {
    staticClass: "content",
    class: {
      'content_enlarged-example-gap': _vm.enlargedExampleGap
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Basic usage"
    }
  }, [_vm._t("basicUsage")], 2), _vm._t("default")], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }